<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->

                    <!-- Row -->
                    <div class="row" v-if="data.cod">                       
                        <div class="col-xl-6 col-xl-offset-3 col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div style="height: 14vh;" class="hidden-lg hidden-xl hidden-xs"></div>
                                    <div style="height: 10vh;" class="hidden-lg hidden-xl hidden-md"></div>
                                    <div style="height: 14vh;" class="hidden-xs"></div>
                                    <div class="dashboard-headline center">
                                        <h3>
                                            Avalie o atendimento de {{data.prestador.nome}}
                                        </h3>
                                    </div>
                                </div>
                            
                                <div class="col-lg-12 center-lg center-xs margin-bottom-10">
                                    <h5>Nota</h5>
                                    <button class="button margin-bottom-5" v-on:click="setNota(1)" v-bind:class="{'green': form.nota == 1, 'gray': form.nota != 1}">
                                        1
                                    </button>
                                    <button class="button margin-bottom-5" v-on:click="setNota(2)" v-bind:class="{'green': form.nota == 2, 'gray': form.nota != 2}">
                                        2
                                    </button>
                                    <button class="button margin-bottom-5" v-on:click="setNota(3)" v-bind:class="{'green': form.nota == 3, 'gray': form.nota != 3}">
                                        3
                                    </button>
                                    <button class="button margin-bottom-5" v-on:click="setNota(4)" v-bind:class="{'green': form.nota == 4, 'gray': form.nota != 4}">
                                        4
                                    </button>
                                    <button class="button margin-bottom-5" v-on:click="setNota(5)" v-bind:class="{'green': form.nota == 5, 'gray': form.nota != 5}">
                                        5
                                    </button>                                                                                                                                           
                                </div>
                                <div class="col-lg-12 clearfix"></div>
                                <div class="col-lg-12 center-lg center-xs">
                                    <h5>Comentário</h5>
                                    <textarea class="with-border" placeholder="Escreva algum comentário..." v-model="form.texto" name="texto"></textarea>
                                </div>      

                                <div class="col-lg-12">
                                    <center>
                                        <button class="button margin-top-10 green big" type="button" v-on:click="submit()"><i class="material-icons">check</i> Confirmar avaliação</button>
                                    </center>
                                </div>  
                            </div>  
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Avaliacao',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             "",
                "pedidoCod":        "",
                "nota":             0,
                "texto":            ""
            }              
        }
    },
    methods: {
        setNota(nota) {
            var self    = this;
            self.form.nota = nota;
            self.$forceUpdate();
        },
        submit(e) {
            if (e) e.preventDefault();
            var self                = this;
            var form                = self.form;
            loading.show();

            axios.post("api/avaliacoes.php", self.form)
            .then(response => {
                
                alert(response.data.message);
                self.$root.go("Dashboard");

            })
            .catch(error => {
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });                     
        },        
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/avaliacoes.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    // self.$root.back();
                    self.$root.go("Dashboard");
                    reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },   
    },
    created: function() {
        var self = this;
        // http://localhost:8080/#/avaliacao?n=2&c=4962e56c5f26b2bb0458e02a1d9be7fc&_cod=a80014ff99335ef0f3058935c38f4276
        if (!self.$route.query.c || !self.$route.query._cod) {
            self.$root.go("Dashboard");

            return false;
        }      

        if (self.$route.query.n && isNaN(self.$route.query.n) == false) {
            self.setNota(self.$route.query.n);
        }

        self.form.pedidoCod     = self.$route.query.c;
        self.form._cod          = self.$route.query._cod;
        self.get();          
    },
    mounted: function() {
        // loading.hide();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .button.margin-bottom-5 {
        font-size: 20px;
    }
    .button.green {
        border: 2px solid #30ab4a !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Avaliacao.vue